module.exports = __webpack_public_path__ + "img/Katarina_entertainment.842d59a9.jpg";